import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getAllPermissionList = (page, pagesize, search, ordering) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/get-all-permission-list/`, {
        headers: authHeader(),
        params: {
            page: page,
            pagesize: pagesize,
            search: search, // You might want to include search here, if applicable
            ordering: ordering
        },
    });
};



const permissionService = {
    getAllPermissionList,
};

export default permissionService;
